import { useAutorizacao } from "view/component/Autorizacao/useAutorizacao";
import { RestricoesCamposFormulario } from "../RestricoesCamposFormulario";
import { RestricoesFormulario } from "../RestricoesFormulario";


export const useRestricoesFormulario = <
  RestricoesPapeis extends RestricoesFormulario<RestricoesCamposFormulario>
>(restricoes: RestricoesPapeis): RestricoesCamposFormulario => {
  const autorizacao = useAutorizacao();
  const maiorPermissao = autorizacao.maiorPermissao;
  const restricoesPapel = restricoes[maiorPermissao]

  return restricoesPapel;
}
